// extracted by mini-css-extract-plugin
module.exports = {"container":"Cannons-module--container--3tAx4","list":"Cannons-module--list--26bsu","subtitle":"Cannons-module--subtitle--3_bzr"};